<template>
  <div id="particularites">
    <router-link to="/horaires">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Particularités</h2>
    <a
      :class="filteredParticularites.length <= 0?`disabled-link`:``"
      href="javascript:"
      class="mr-3"
      @click="generatePDF()"
    >
      <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
    </a>
    <div class="mt-3 form-inline filtre">
      <label for="begindate">Date de début</label>
      <date-picker
        name="begindate"
        @change="onDateChange"
        format="dd DD/MM/YYYY"
        v-model="filters.begindate"
      ></date-picker>
      <label class="ml-1" for="enddate">Date de fin</label>
      <date-picker
        id="enddate"
        @change="onDateChange"
        format="dd DD/MM/YYYY"
        v-model="filters.enddate"
      ></date-picker>
      <label class="ml-1" for="site">Site</label>
      <select id="site" name="site" class="form-control custom-select" v-model="filters.site">
        <option selected :value="undefined">-</option>
        <option v-for="site in sites" v-bind:key="site.id" v-bind:value="site.id">{{site.nom}}</option>
      </select>
    </div>
    <p v-if="datealert">
      <img class="imgicon" src="img/warning_yellow.png" />&nbsp;La date de début doit être inférieure à la date de fin
    </p>
    <button @click="addParticularite()" class="mt-4 btn btn-success btn-sm">
      <font-awesome-icon :icon="'plus'" />&nbsp;Ajouter une particularité
    </button>
    <b-pagination
      v-if="filteredParticularites.length > 0"
      class="mt-3"
      v-model="currentPage"
      :total-rows="filteredParticularites.length"
      :per-page="perPage"
      aria-controls="table-particularites"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="filteredParticularites"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      class="mt-3"
      id="table-particularites"
      v-if="filteredParticularites.length > 0"
      small
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
    >
      <template v-slot:table-colgroup="scope">
        <col v-for="field in scope.fields" :key="field.key" :width="'20%'" />
      </template>
      <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
      <template v-slot:cell(sites)="data">
        <span v-for="site of data.item.sites" :key="site">{{sitesById[site].nom}}&nbsp;</span>
      </template>
      <template v-slot:cell(titre)="data">{{data.item.titre}}</template>
      <template v-slot:cell(modifier)="data">
        <router-link
          :to="`/horaires/partic/${data.item.id}`"
          class="btn btn-secondary btn-sm"
          style="color: white"
          title
        >
          <font-awesome-icon :icon="'pen'" />&nbsp;Modifier
        </router-link>
      </template>
      <template v-slot:cell(supprimer)="data">
        <button @click="deleteParticularite(data.item)" class="btn btn-danger btn-sm" style="color: white">
          <font-awesome-icon :icon="'trash'" />&nbsp;Supprimer
        </button>
      </template>
    </b-table>
    <p v-else>Rien à signaler...</p>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/utils";
import moment from "moment";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      utils,
      particularites: [],
      sites: [],
      sitesById: [],
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "date", label: "Date", sortable: true },
        { key: "sites", label: "Site(s)", sortable: true },
        { key: "titre", label: "titre", sortable: false },
        { key: "modifier", label: "Modifier", sortable: false },
        { key: "supprimer", label: "Supprimer", sortable: false }
      ],
      filters: {
        begindate: null,
        enddate: null,
        site: undefined
      },
      datealert: false
    };
  },
  components: {DatePicker},
  async created() {
    this.$store.commit("setLoading", true);
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.particularites = (await api.getParticularites()).data.particularites;
    this.$store.commit("setLoading", false);
  },
  methods: {
    async addParticularite() {
      const options = [];
      let checkboxes = "";
      for (let site of this.sites) {
        checkboxes += `<div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input" id="switchSite${site.id}"><label class="custom-control-label" for="switchSite${site.id}">${site.nom}</label></div>`;
      }
      await Swal.fire({
        title: "Nouvelle particularité",
        html:
          '<div class="form-group"><label class="col-form-label" for="titre">Default input</label><input style="color: black" type="text" class="form-control" placeholder="Titre" id="titre"></div>' +
          `<div class="form-group"><label class="col-form-label for="date">Date</label><input class="form-control" type="date" name="date" id="date"/></div>` +
          `<h5>Sites</h5>` +
          checkboxes +
          `<br>` +
          '<textarea id="contenu" placeholder="Contenu" class="form-control"/>',
        focusConfirm: false,
        preConfirm: () => {
          let sites = [];
          for (let site of this.sites) {
            if (document.getElementById(`switchSite${site.id}`).checked) {
              sites.push(site.id);
            }
          }
          return [
            {
              titre: document.getElementById("titre").value,
              sites,
              contenu: document.getElementById("contenu").value,
              date: document.getElementById("date").value
            }
          ];
        }
      }).then(async result => {
        if (result.value) {
          let particularite = {
            titre: result.value[0].titre,
            sites: result.value[0].sites,
            contenu: result.value[0].contenu,
            date: result.value[0].date
          };
          if (
            particularite.titre &&
            particularite.sites &&
            particularite.contenu &&
            particularite.date
          ) {
            let response = await api.createParticularite(particularite);
            if (response.code === 200) {
              this.particularites = (
                await api.getParticularites()
              ).data.particularites;
            }
            Toast.fire({
              type: response.code === 200 ? "success" : "error",
              title: response.message
            });
          } else {
            Toast.fire({
              type: "warning",
              title: "Certains champs sont vides."
            });
          }
        }
      });
    },
    async deleteParticularite(particularite) {
      let response = await api.deleteParticularite(particularite.id);
      if (response.code === 200) {
        this.particularites.splice(
          this.particularites.indexOf(particularite),
          1
        );
      }
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        title: response.message
      });
    },
    onDateChange() {
      this.datealert =
        this.filters.begindate !== null &&
        this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, 'day');
    },
    generatePDF() {
      const filter = {
        begindate: moment(this.filters.begindate).utc(true).toDate(),
        enddate: moment(this.filters.enddate).utc(true).toDate(),
        site: this.filters.site
      }
      api.pdf(`particularites`, { filters: filter }, `particularites`);
    }
  },
  computed: {
    filteredParticularites() {
      return this.particularites.filter(particularite => {
        let ok = true;
        if (ok && this.filters.site !== undefined) {
          if (particularite.sites.indexOf(this.filters.site) === -1) {
            ok = false;
          }
        }
        if (ok && this.filters.begindate !== null) {
          if (moment(particularite.date).isBefore(this.filters.begindate, 'day')) {
            ok = false;
          }
        }
        if (ok && this.filters.enddate !== null) {
          if (moment(particularite.date).isAfter(this.filters.enddate, 'day')) {
            ok = false;
          }
        }
        return ok;
      });
    }
  }
};
</script>